module.exports = __webpack_public_path__ + "img/mecha-head.74c06704.svg";